import type {
  AdminCard,
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import { primaryAdminViews } from "../admin-pages.js";

export function withModal(
  id: string,
  baseId: string,
  modal: AdminOverlayDefinition,
): AdminViewDefinition {
  return { ...baseView(baseId), id, baseViewId: baseId, modal };
}

export function withDrawer(
  id: string,
  baseId: string,
  drawer: AdminOverlayDefinition,
): AdminViewDefinition {
  return { ...baseView(baseId), id, baseViewId: baseId, drawer };
}

function baseView(id: string): AdminViewDefinition {
  const view = primaryAdminViews.find((item) => item.id === id);
  if (view === undefined) {
    throw new Error(`Missing admin base view ${id}`);
  }

  return view;
}

export function modal(
  title: string,
  body: AdminCard[],
  actions: AdminOverlayDefinition["actions"],
): AdminOverlayDefinition {
  return { title, size: "lg", body, ...(actions === undefined ? {} : { actions }) };
}

export function drawer(
  title: string,
  description: string,
  body: AdminCard[],
  actions?: AdminOverlayDefinition["actions"],
): AdminOverlayDefinition {
  return { title, description, body, ...(actions === undefined ? {} : { actions }) };
}

export function card(title: string, values: string[]): AdminCard {
  return { title, rows: values.map(toRow) };
}

function toRow(value: string): { label: string; value: string } {
  const [label = "", detail] = value.split(" - ");
  return { label, value: detail ?? "" };
}
